import script from "./infoMobile.vue?vue&type=script&setup=true&lang=js"
export * from "./infoMobile.vue?vue&type=script&setup=true&lang=js"

import "./infoMobile.vue?vue&type=style&index=0&id=07aeb74f&scoped=true&lang=less"

import exportComponent from "/workspace/office-website/company-website/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-07aeb74f"]])

export default __exports__